// extracted by mini-css-extract-plugin
export default {"signUpSection":"SignUpAside_signUpSection__kw9gQ"};